import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const domoticz = defineConnector({
  identifier: "domoticz",
  name: "Domoticz",
  tagLine: "Open-source home automation system",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl || "http://domoticz.local:8080"),
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Use your Domoticz login",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the URL you use to reach Domoticz, along with a Domoticz username and password. If your instance is served over plain HTTP, first enable “Allow Basic Authentication over plain HTTP” under Setup → Settings → Security.",
        },
      ],
    },
    {
      title: "Enter your Domoticz details",
      items: [
        {
          kind: "baseUrl",
          label: "Domoticz URL",
          placeholder: "http://domoticz.local:8080",
          required: true,
          helperText: "The base URL you use to reach Domoticz.",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "http://domoticz.local:8080"}/json.htm?type=command&param=getversion`,
  },
});
